import Backend from '../../utils/api';

export function safeCredentialUrl(value) {
  if (typeof value !== 'string') return null;
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch { return null; }
}

// Read only the public class metadata for this tool; never load recipients or tokens.
export async function loadToolCredentials(toolId) {
  if (toolId == null) throw new Error('Missing tool');
  const mappings = [];
  for (let page = 1; ; page += 1) {
    const result = await Backend.apiCallV2('/badges/', 'GET', null, { page, per_page: 200 });
    if (result.status !== 200 || !Array.isArray(result.data) || !Number.isFinite(result.total)) throw new Error('Credential requirements unavailable');
    mappings.push(...result.data.filter(item => String(item.tool_id) === String(toolId)));
    if (page * 200 >= result.total) break;
    if (result.data.length === 0) throw new Error('Incomplete credential requirements');
  }
  const unique = [...new Map(mappings.map(item => [`${item.provider}:${item.badge_class_entity_id}`, item])).values()];
  return Promise.all(unique.map(async mapping => {
    try {
      const info = await Backend.apiCallV2(`/badges/classes/${encodeURIComponent(mapping.badge_class_entity_id)}`, 'GET', null, { provider: mapping.provider || 'parchment' });
      if (info.status !== 200 || typeof info.name !== 'string' || !info.name.trim()) return null;
      return {
        id: `${mapping.provider}:${mapping.badge_class_entity_id}`,
        name: info.name,
        description: typeof info.description === 'string' ? info.description : '',
        criteria: typeof info.criteriaNarrative === 'string' ? info.criteriaNarrative : typeof info.criteria?.narrative === 'string' ? info.criteria.narrative : '',
        url: safeCredentialUrl(info.criteriaUrl || info.criteria?.id || info.criteria?.url || info.criteria),
      };
    } catch { return null; }
  }));
}
